import { Menu } from 'antd';
import React, { FunctionComponent } from 'react';
import { MenuProps } from 'antd/lib/menu';
import { MenuItemProps } from 'antd/lib/menu/MenuItem';
import classNames from 'classnames';
import { IAutomatable, preventDataAutomationOverriding } from '../../helpers/IAutomatable';

export interface VtxMenuProps extends MenuProps, IAutomatable {}
export interface VtxMenuItemProps extends MenuItemProps, IAutomatable {}

export const VtxMenu: FunctionComponent<VtxMenuProps> = React.memo((props: VtxMenuProps) => {
    const automationClass = 'vtx-menu';
    const { className, ...otherProps } = preventDataAutomationOverriding(props);
    const classNamesCombined = classNames(automationClass, className);
    return (
        <Menu data-automation-class={automationClass} className={classNamesCombined} {...otherProps}></Menu>
    );
});

export const VtxMenuItem: FunctionComponent<VtxMenuItemProps> = React.memo((props: VtxMenuItemProps) => {
    const automationClass = 'vtx-menu-item';
    const { className, ...otherProps } = preventDataAutomationOverriding(props);
    const classNamesCombined = classNames(automationClass, className);
    return (
        <Menu.Item
            data-automation-class={automationClass}
            className={classNamesCombined}
            {...otherProps}
        ></Menu.Item>
    );
});
